export class RenewalPlan {
    public displayRent: string;
    public displayTerm: string;
    constructor(
        public LeaseRenewalPlanKey: number = null,
        public NewRent: number = null,
        public RenewalLeaseTerm: number,
        public MTMActiveDate: Date = null,
        public ChosenPlan: boolean = null,
        public Title: string = null
    ) {
        this.setDisplayValues();
    }

    setDisplayValues() {
        this.displayRent = `$${this.NewRent}/mo`;
        this.displayTerm = `${this.RenewalLeaseTerm} month${this.RenewalLeaseTerm === 1 ? '' : 's'}`;
    }
}
